import { Component, OnDestroy, OnInit } from '@angular/core';
import { AdminService } from 'app/admin/admin.service';
import { NofshonimSummaryExportExcel } from 'app/admin/interface/reports/export-excel/nofshonim-summary.interface';
import { NofshonimSummaryReport } from 'app/admin/interface/reports/nofshonim-summary-report.interface';
import { ConfigService } from 'app/shared/config.service';
import { ResultOfOperation } from 'app/shared/model/result-of-operation.model';
import { UserMessagesService } from 'app/shared/user-messages/user-messages.service';

@Component({
  selector: 'app-nofshonim-summary',
  templateUrl: './nofshonim-summary.component.html',
  styleUrls: ['./nofshonim-summary.component.css']
})
export class NofshonimSummaryComponent implements OnInit, OnDestroy {

  nofashimReport: NofshonimSummaryReport[];
  isLoading: boolean = false;
  reportIssueTime: string;
  private _intervalId;
  private readonly _itervalTime: number = 1 * 60 * 1000;
  updateIntervalMinutes: number = this._itervalTime / (60 * 1000);
  totals = {
    maxRoomsTichnun: 0,
    maxRoomsTichnunHamtana: 0,
    reservedRooms: 0,
    reservedRoomsHamtana: 0,
    nirshamim: 0,
    mamtinim: 0
  };

  readonly exportExcelUrl: string;
  exportExcelFilename = "סיכום נופשונים";
  exportExcelData: NofshonimSummaryExportExcel;

  constructor(private _config: ConfigService, private _adminService: AdminService, private _userMessagesService: UserMessagesService) 
  { 
    const apiUrl = this._config.getConfigPropertyByKey("apiUrl");
    this.exportExcelUrl = `${apiUrl}/api/Admin/ExportNofshonimSummaryReportToExcel`
  }

  ngOnInit() {

    if(!this.nofashimReport)
    {
      this._getNofashimReport();
    }

    this._intervalId = setInterval(() => {
      this._getNofashimReport();
    }, this._itervalTime);
  }

  private _getNofashimReport(): void
  {
    this.isLoading = true;
    this._adminService.getNofshonimSummaryReport().subscribe((response: ResultOfOperation<NofshonimSummaryReport[]>) => {
      this.isLoading = false;
      if(response.isSuccess && response.data)
      {
        this.reportIssueTime = this._adminService.getReportIssueTime();
        this.nofashimReport = response.data;

        const rishumDates = this.nofashimReport
          .filter(n => n.rishumFrom !== null)
          .map(n => new Date(n.rishumFrom))
          .sort((a, b) => {
            if(a <= b) return -1;
            return 1;
          });
        this.exportExcelFilename += (rishumDates !== null && rishumDates.length > 0) ? ` - ${rishumDates[0].toLocaleDateString("he-IL").replace(/\./g, "_")}` : "";
        
        this.exportExcelData = {
          content: this.nofashimReport,
          header: this.exportExcelFilename,
          timestamp: this.reportIssueTime
        }
        this._calculateTotals(response.data);
      }
      else if(!response.isSuccess)
      {
        this._userMessagesService.setErrorMessage("אירעה שגיאה בטעינת הנתונים");
      }
    }),
    error => {
      this.isLoading = false;
      this._userMessagesService.setErrorMessage("אירעה שגיאה בטעינת הנתונים");
    };
  }

  private _calculateTotals(nofashim: NofshonimSummaryReport[]): void
  {
    this.totals.maxRoomsTichnun = nofashim
      .map(nofesh => nofesh.maxRoomsTichnun)
      .reduce((acc, value) => acc + value, 0);

    this.totals.maxRoomsTichnunHamtana = nofashim
      .map(nofesh => nofesh.maxRoomsTichnunHamtana)
      .reduce((acc, value) => acc + value, 0);

    this.totals.reservedRooms = nofashim
      .map(nofesh => nofesh.totalReservedRooms)
      .reduce((acc, value) => acc + value, 0);
    
    this.totals.reservedRoomsHamtana = nofashim
      .map(nofesh => nofesh.totalReservedRoomsHamtana)
      .reduce((acc, value) => acc + value, 0);
    
    this.totals.nirshamim = nofashim
      .map(nofesh => nofesh.totalNirshamim)
      .reduce((acc, value) => acc + value, 0);
    
    this.totals.mamtinim = nofashim
      .map(nofesh => nofesh.totalMamtinim)
      .reduce((acc, value) => acc + value, 0);
  }

  ngOnDestroy(): void
  {
    if(this._intervalId)
    {
      clearInterval(this._intervalId);
    }
  }

}
